import script from "./esAccountSettings.vue?vue&type=script&lang=ts&setup=true"
export * from "./esAccountSettings.vue?vue&type=script&lang=ts&setup=true"

import "./esAccountSettings.vue?vue&type=style&index=0&id=52ded13b&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52ded13b"]])

export default __exports__